require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-find-the-right-program-for-you.json") })
        }
      }, "path---blog-find-the-right-program-for-you");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-find-the-right-program-for-you!./.cache/json/blog-find-the-right-program-for-you.json
// module id = 799
// module chunks = 231608221292675